import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-featuredetection-js/ApplicationFeatures';
import _ from 'underscore';
import moment from 'moment';
import DateUtil from 'gw-portals-util-js/DateUtil';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

var fn = function fn($scope, $rootScope, submissionViewModel, UserService, $filter) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    var actualDate = new Date();
    var actualExpDate = new Date();

    ctrl.init = function () {
        $scope.submissionVM = submissionViewModel();
        $rootScope.updatePeriodEndDate = $scope.updateEnd;
        var actDate = new Date();
        var today = new Date(actDate);
        var startDates = {}; //angular.copy($scope.submissionVM.baseData.periodStartDate.value)
        startDates.day = today.getDate();
        startDates.month = today.getMonth();
        startDates.year = today.getFullYear() - 1;
        $scope.minStartDate = startDates;
        $scope.expDateDisable = true;
        $scope.constructionVisibleError = false;
        $scope.producerCodesPromise = UserService.getProducerCodesAndGroupsForCurrentUser();
        $scope.producerCodesPromise.then(function (producerCodesResponse) {

            $scope.producerCodes = producerCodesResponse.mSFProducerCodes_EXT;
            $scope.producerGroups = producerCodesResponse.mSFGroups_EXT;
            $scope.Organization = producerCodesResponse.mSFOrganization_EXT;
            $scope.submissionVM.baseData.mSFOrganization_EXT = {
                aspects: {
                    // inputCtrlType: "text",
                    required: false,
                    visible: true,
                    get validationMessages() {
                        // return
                        // [$filter('translate')('gateway.views.new-quote.errors.This
                        // is a required field')];
                        return ['This is a required field'];
                    },
                    get valid() {
                        return $scope.submissionVM.baseData.mSFOrganization_EXT.value;
                    }

                },
                value: $scope.Organization
            };

            $scope.serviceSuccess = true;

            $scope.newType = $scope.submissionVM.baseData.termType.aspects.availableValues;
            $scope.newType = _.reject($scope.newType, { code: 'Other' });
            $scope.newType = _.reject($scope.newType, { code: 'HalfYear' });
            var hideChooseOption = angular.element(document.querySelector('.hide-placeholder')); // Added for IE bug related to option hide_MSF
            var inlineErrorMsg = angular.element(document.querySelector('.gw-inline-messages'));
            hideChooseOption.attr('disabled', 'disabled');
            inlineErrorMsg.css('display', 'block');
            var end = angular.element("#periodEndDate").find("#localDateChooser").val().split('/');
            $scope.updateEnd = {
                year: end[2],
                month: end[0] - 1,
                day: end[1]
            };
            $rootScope.updatePeriodEndDate = $scope.updateEnd;
        });

        // validateEffectiveDates('start');
    };

    $scope.$watch('submissionVM.baseData.mSFConstructionDate.value', resetConstructionVisibleError);
    $scope.$watch('submissionVM.baseData.isMSFMTConstrOpEngaged.value', toggleConstructionDates);
    $scope.$watch('validationMsg', blurInputField); //Added to highlight invalid field

    $scope.$watch('submissionVM.baseData.termType.value', function (newValue, oldValue) {

        if (newValue !== oldValue) {
            toggleCoverageDates();
        }
    });
    $scope.$watch('submissionVM.baseData.periodStartDate.value', function (newVal, oldVal) {
        validateEffectiveDates('start');
        if ($scope.validationMsg === false) {
            var now = new Date();
            var stateCoverageDate = new Date();
            stateCoverageDate.setMonth($scope.submissionVM.baseData.mSFEREffectiveDate.value.month);
            stateCoverageDate.setDate($scope.submissionVM.baseData.mSFEREffectiveDate.value.day);
            stateCoverageDate.setYear($scope.submissionVM.baseData.mSFEREffectiveDate.value.year);
            if (now >= stateCoverageDate) {
                $scope.submissionVM.baseData.mSFEREffectiveDate.value = $scope.submissionVM.baseData.periodStartDate.value;
            }
        }
    });
    $scope.$watch('submissionVM.baseData.periodEndDate.value', function (newVal, oldVal) {
        validateEffectiveDates('end');
    });
    function toggleConstructionDates() {
        if (!submissionVM.baseData.isMSFMTConstrOpEngaged.value) {
            $scope.submissionVM.baseData.mSFConstructionDate.value = undefined;
        }
    }
    function blurInputField() {
        if ($scope.validationMsg) {
            angular.element("#periodEndDate :input").css('border-color', '#dca5a4');
        } else {
            angular.element("#periodEndDate :input").css('border-color', '#ccc');
        }
    }
    function toggleCoverageDates() {
        var actualDate = new Date();
        var startDate = $scope.submissionVM.baseData.periodStartDate.value.day;
        var startMonth = $scope.submissionVM.baseData.periodStartDate.value.month;
        actualDate.setMonth($scope.submissionVM.baseData.periodStartDate.value.month);
        actualDate.setDate($scope.submissionVM.baseData.periodStartDate.value.day);
        actualDate.setYear($scope.submissionVM.baseData.periodStartDate.value.year);

        if ($scope.submissionVM.baseData.termType.value.code == "Annual") {
            $scope.expDateDisable = true;
            var setExpDates = new Date(actualDate);
            setExpDates.setDate(startDate + 365); //Adding one year
            $scope.submissionVM.baseData.periodEndDate.value.day = setExpDates.getDate();
            $scope.submissionVM.baseData.periodEndDate.value.month = setExpDates.getMonth();
            $scope.submissionVM.baseData.periodEndDate.value.year = setExpDates.getFullYear();
        } else if ($scope.submissionVM.baseData.termType.value.code == "msfextended_ext") {
            var setExpDates = new Date(actualDate);
            setExpDates.setDate(startDate + 381);
            $scope.submissionVM.baseData.periodEndDate.value.day = setExpDates.getDate();
            $scope.submissionVM.baseData.periodEndDate.value.month = setExpDates.getMonth();
            $scope.submissionVM.baseData.periodEndDate.value.year = setExpDates.getFullYear();
        } else if ($scope.submissionVM.baseData.termType.value.code == "msfshortterm_ext") {
            var setExpDates = new Date(actualDate);
            setExpDates.setMonth(startMonth + 6); //Adding 6 months
            $scope.submissionVM.baseData.periodEndDate.value.day = setExpDates.getDate();
            $scope.submissionVM.baseData.periodEndDate.value.month = setExpDates.getMonth();
            $scope.submissionVM.baseData.periodEndDate.value.year = setExpDates.getFullYear();
        }
    }
    function validateEffectiveDates(filter) {
        $scope.validationMsg = false;
        if (angular.element("#periodEndDate").find("#localDateChooser").val() != undefined) {
            var end = angular.element("#periodEndDate").find("#localDateChooser").val().split('/');
            $scope.updateEnd = {
                year: end[2],
                month: end[0] - 1,
                day: end[1]
            };
            $rootScope.updatePeriodEndDate = $scope.updateEnd;
        }
        actualDate.setMonth($scope.submissionVM.baseData.periodStartDate.value.month);
        actualDate.setDate($scope.submissionVM.baseData.periodStartDate.value.day);
        actualDate.setYear($scope.submissionVM.baseData.periodStartDate.value.year);
        actualExpDate.setMonth($scope.submissionVM.baseData.periodEndDate.value.month);
        actualExpDate.setDate($scope.submissionVM.baseData.periodEndDate.value.day);
        actualExpDate.setYear($scope.submissionVM.baseData.periodEndDate.value.year);
        if (filter == 'start') {
            if ($scope.submissionVM.baseData.periodStartDate.value.month != undefined || $scope.submissionVM.baseData.periodStartDate.value.day != undefined || $scope.submissionVM.baseData.periodStartDate.value.year != undefined) toggleCoverageDates();
        }
        var diffDays = Math.round(Math.abs((actualDate.getTime() - actualExpDate.getTime()) / oneDay));
        angular.element("#periodEndDate :input").attr('readonly', 'readonly');
        angular.element("#periodStartDate :input").attr('readonly', 'readonly');

        if ($scope.submissionVM.baseData.termType.value.code == "Annual") {
            angular.element("#periodEndDate :input").attr('disabled', 'disabled');
            angular.element("#periodEndDate .datetimepicker-icon").css('display', 'none');
        } else if ($scope.submissionVM.baseData.termType.value.code == "msfextended_ext") {
            angular.element("#periodEndDate :input").removeAttr('disabled');
            angular.element("#periodEndDate .datetimepicker-icon").css('display', 'block');
            if (diffDays < 365 || diffDays > 381) {
                $scope.dateValidationMsg = $filter('translate')('quoteandbind.wizard.step.Extended Expiration Date Validation Msg');
                $scope.validationMsg = true;
            } else {
                $scope.validationMsg = false;
            }
        } else if ($scope.submissionVM.baseData.termType.value.code == "msfshortterm_ext") {
            var today = DateUtil.currentDate();
            if (actualDate >= actualExpDate && actualExpDate > today) {
                $scope.dateValidationMsg = $filter('translate')('quoteandbind.wizard.step.Short Expiration Date Validation Msg for periodEndDate');
                $scope.validationMsg = true;
            } else {
                angular.element("#periodEndDate :input").removeAttr('disabled');
                angular.element("#periodEndDate .datetimepicker-icon").css('display', 'block');
                if (diffDays > 364) {
                    $scope.dateValidationMsg = $filter('translate')('quoteandbind.wizard.step.Short Expiration Date Validation Msg');
                    $scope.validationMsg = true;
                } else {
                    $scope.validationMsg = false;
                }
            }
        }
    }

    function resetConstructionVisibleError() {
        $scope.constructionVisibleError = false;
    }

    ctrl.next = function (nextFn, form) {

        if ($scope.submissionVM.baseData.isMSFMTConstrOpEngaged.value == true) {
            if ($scope.submissionVM.baseData.mSFConstructionDate.value == undefined) {
                $scope.constructionVisibleError = true;
                return false;
            }
        }
        if ($scope.validationMsg) return false;
        /*else
        {
        	$scope.submissionVM.baseData.mSFConstructionDate.value = undefined;
        }*/

        nextFn($scope.submissionVM, form.valid);
    };

    /*
    * function getProducerCodes() { const producerCodesPromise =
    * UserService.getAvailableProducerCodesForCurrentUser();
    * producerCodesPromise.then((producerCodesResponse) => {
    * $scope.producerCodes = producerCodesResponse; }); }
    */

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$rootScope', 'submissionViewModel', 'UserService', '$filter'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/quoteandbind/common/controllers/EffectiveDateCtrl.js
// module id = 117
// module chunks = 0